import { Children } from 'react';
import { Typography } from '../Typography/Typography.js';
import { getSectionLayoutStyles, getSectionLayoutTitleStyles, getSectionLayoutWrapperStyles } from './SectionLayoutStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Section } from '../Section/Section.js';

const SectionLayout = _ref => {
  let {
    title,
    children,
    vertical = false,
    ...rest
  } = _ref;
  return jsxs("article", {
    css: getSectionLayoutStyles,
    ...rest,
    children: [title && jsx(Typography, {
      css: getSectionLayoutTitleStyles,
      component: "h5",
      variant: "subtitle2",
      children: title
    }), children && jsx("div", {
      css: getSectionLayoutWrapperStyles(vertical),
      children: Children.map(children, child => child.type === Section ? child : null)
    })]
  });
};

export { SectionLayout };
//# sourceMappingURL=SectionLayout.js.map
